import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ValetChatList from './ValetChatList';
import {getAllValetRaisedTickets} from "services/redux/Valet/Project/action";

const mapStateToProps = (state) => ({
  allRaisedTicketsList: state.CreateProject.allRaisedTicketsList
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getAllValetRaisedTickets
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ValetChatList);
